import { Capacitor } from '@capacitor/core';

export const lockPortraitOrientation = (): void => {
  if (Capacitor.isNativePlatform()) {
    return;
  }
  void window.screen?.orientation?.lock?.('portrait').catch(() => undefined);
};
